import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isStoreVisible',
  standalone: true,
})
export class IsStoreVisible implements PipeTransform {
  transform(storesVisible: Set<string> | null, uuid: string): boolean {
    return storesVisible ? storesVisible.has(uuid) : false;
  }
}
